import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import h5Address from "@/extension/h5/address/index"

addCustomWidgetSchema({
  type: 'h5Address',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '地址',
    columnWidth: '200px',
    required: false,
    url: '/jumper-mih/nt/baseArea/areaList?parentId=',
    labelWidth: '110',
    labelHidden: true,
    labelAlign: 'label-right-align',
    requiredHint: '请选择地址',
    defaultValue: '440000000000,440300000000,440305000000,440305003000',
    addressLv: null,
    labelKey: 'dicValue',
    valueKey: 'dicKey',
    placeholder: '',
    textAlign: "left",//文字对齐方式
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: ''
  }
})  //加载组件Json Schema

Vue.component(h5Address.name, h5Address)  //注册组件

PERegister.registerCPEditor('addressLv', 'addressLv-editor',
  PEFactory.createInputTextEditor('addressLv', '行政区划级别'))